import { forwardRef, Ref, useEffect, useImperativeHandle, useRef } from "react";

import { svgPathData as faCirclePath } from "@fortawesome/pro-solid-svg-icons/faCircle";

import colors from "@app/styles/_colors.module.scss";

type LatLngLiteral = google.maps.LatLngLiteral;

interface Props extends google.maps.MarkerOptions {
  center: LatLngLiteral;
}

const CenterMarker = ({ center, map }: Props, ref: Ref<google.maps.Marker | null>) => {
  const centerMarker = useRef<google.maps.Marker | null>(null);
  useEffect(() => {
    if (!map) {
      return;
    }
    const scale = 0.05;
    const anchor = new window.google.maps.Point(200, 510);
    const labelOrigin = new window.google.maps.Point(200, 205);
    const path = faCirclePath;
    centerMarker.current = new google.maps.Marker({
      icon: {
        anchor,
        fillColor: colors.red075,
        fillOpacity: 1,
        labelOrigin,
        path,
        scale,
        strokeColor: colors.white,
        strokeWeight: 4,
      },
      map: map,
      position: center,
      //adding an arbitrary negative z-index so other Markers are rendered on top
      zIndex: -100,
    });

    return () => {
      centerMarker.current?.setMap(null);
    };
  }, [map, center]);
  useImperativeHandle(ref, () => centerMarker.current);

  return null;
};

export default forwardRef(CenterMarker);
